<template>
  <Content class="col-span-full" :title="$route.name">
    <Notice class="mb-8">
      {{ $t("HARDWARE_HISTORY_REPORT_NOTE") }}
    </Notice>

    <customerVehicle
      type="hardware"
      @tableData="tableData = $event"
      @tableLoading="tableLoading = $event"
    />

    <hardwareTable
      class="mt-8"
      :tableData="tableData"
      :loading="tableLoading"
    />
  </Content>
</template>

<script>
import Notice from "@/components/elements/notice";
import hardwareTable from "@/components/reports/history/hardwareTable.vue";
import customerVehicle from "@/components/reports/history/customerVehicle.vue";

export default {
  data() {
    return {
      tableData: [],
      tableLoading: false,
    };
  },

  components: {
    Notice,
    hardwareTable,
    customerVehicle,
  },
};
</script>
